export const userColumns = [
    { field: "_id", headerName: "ID", width: 390 },
    {
      field: "department",
      headerName: "Departments",
      width: 400,
    },
  ];
  